import { HttpClient, HttpParams } from '@angular/common/http';
import { Response } from '@angular/http';
import { Injectable} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Tuple, Tuple3 } from '../../entities/global/model';
import { catchError } from 'rxjs/operators';
import { TemperatureInspectionVM, TemperatureInspectionListVM, UpdateTemperatureDateAmbient, LoadInspectionListVM } from './temperature-inspection.module';
import { AddComponentPhotoModel } from '../interpretation/models/interpretation.model';


@Injectable()

export class TemperatureInspectionService {
  private readonly API_BASE = 'api/TemperatureInspection/';
  private readonly GET_PINS_FOR_MODEL = this.API_BASE + 'GetPinsforModel';
  private readonly GET_PINS_FOR_MODEL_BY_EQUIPMENT = this.API_BASE + 'GetPinsforModelByEquipment';
  private readonly CREATE_TEMP_INSPECTION = this.API_BASE + 'CreateTempInspection';
  private readonly VALIDATE_SMU_DATE_TEMP_INSPECTION = this.API_BASE + 'ValidateDateSMU';
  private readonly LOAD_TEMP_INSPECTION_DETAILS = this.API_BASE + 'LoadTemperatureInspections';
  private readonly UPDATE_TEMP_INSPECTION_COMMENT = this.API_BASE + 'UpdateInspectionComment';
  private readonly UPDATE_TEMP_INSPECTION_DETAIL_COMMENT = this.API_BASE + 'UpdateInspectionDetailComment';
  private readonly UPDATE_TEMP_INSPECTION_PHOTO = this.API_BASE + 'UpdateInspectionPhoto';
  private readonly DELETE_TEMP_INSPECTION_PHOTO = this.API_BASE + 'DeleteInspectionPhoto';
  private readonly UPDATE_TEMP_INSPECTION_DETAIL_PHOTO = this.API_BASE + 'UpdateInspectionDetailPhoto';
  private readonly DELETE_TEMP_INSPECTION_DETAIL_PHOTO = this.API_BASE + 'DeleteInspectionDetailPhoto';
  private readonly UPDATE_TEMP_INSPECTION_DETAIL_TEMPERATURE = this.API_BASE + 'UpdateInspectionDetailTemperature';
  private readonly UPDATE_TEMP_INSPECTION_AMBIENT_TEMPERATURE_DATE = this.API_BASE + 'UpdateAmbientTemperatureDate';
  private readonly LOAD_TEMP_INSPECTION_DETAILS_INTERP = this.API_BASE + 'LoadInterpretationTemperatureInspections';
  
 
  constructor(private _http: HttpClient) { }



  public getTemperatureInspectionPins(model: string): Observable<any> {
    let options = {
        params: new HttpParams().set('model', model)
    };
    return this._http.get(this.GET_PINS_FOR_MODEL, options).pipe(catchError(this.handleError));
}

public getTemperatureInspectionPinsByEquipmentId(equipmentId: number): Observable<any> {
  let options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
  };
  return this._http.get(this.GET_PINS_FOR_MODEL_BY_EQUIPMENT, options).pipe(catchError(this.handleError));
}

public CreateTemperatureInspection(model: TemperatureInspectionVM): Observable<Tuple> {
  return this._http.post<Tuple>(this.CREATE_TEMP_INSPECTION, model).pipe(catchError(this.handleError));
}

public ValidateSMUAndDate(model: TemperatureInspectionVM): Observable<Tuple3> {
  return this._http.post<Tuple3>(this.VALIDATE_SMU_DATE_TEMP_INSPECTION, model).pipe(catchError(this.handleError));
}

public LoadTemperatureInspection(equipmentId: number, inspectionId:number): Observable<TemperatureInspectionListVM[]> {
  let options = {
    params: new HttpParams().set('equipmentId', equipmentId.toString()).set('inspectionId', inspectionId.toString())
  };
  return this._http.get<TemperatureInspectionListVM[]>(this.LOAD_TEMP_INSPECTION_DETAILS, options).pipe(catchError(this.handleError));
}

public LoadTemperatureInspectionForInterp(equipmentId: number, inspectionId:number): Observable<TemperatureInspectionListVM[]> {
  let options = {
    params: new HttpParams().set('equipmentId', equipmentId.toString()).set('inspectionId', inspectionId.toString())
  };
  return this._http.get<TemperatureInspectionListVM[]>(this.LOAD_TEMP_INSPECTION_DETAILS_INTERP, options).pipe(catchError(this.handleError));
}


public updateInspectionComment(inspectionID:number, comment:string): Observable<Tuple> {
  let options = {
    params: new HttpParams().set('inspectionID', inspectionID.toString()).set('comment', comment)
  };
  return this._http.get<Tuple>(this.UPDATE_TEMP_INSPECTION_COMMENT, options).pipe(catchError(this.handleError));
}

public updateInspectionDetailComment(inspectionDetailID:number, comment:string): Observable<Tuple> {
  let options = {
    params: new HttpParams().set('inspectionDetailID', inspectionDetailID.toString()).set('comment', comment)
  };
  return this._http.get<Tuple>(this.UPDATE_TEMP_INSPECTION_DETAIL_COMMENT, options).pipe(catchError(this.handleError));
}

public addTemperatureInspectionPhoto(photo: AddComponentPhotoModel): Observable<Tuple> {
  return this._http.post<Tuple>(this.UPDATE_TEMP_INSPECTION_PHOTO, photo).pipe(catchError(this.handleError));
}

public deleteTemperatureInspectionPhoto(inspectionId: number): Observable<any> {
  const options = {
    params: new HttpParams()
    .set('inspectionId', inspectionId.toString())
  };
  return this._http.get(this.DELETE_TEMP_INSPECTION_PHOTO, options).pipe(catchError(this.handleError));
}

public addTemperatureInspectionDetailPhoto(photo: AddComponentPhotoModel): Observable<Tuple> {
  return this._http.post<Tuple>(this.UPDATE_TEMP_INSPECTION_DETAIL_PHOTO, photo).pipe(catchError(this.handleError));
}

public deleteTemperatureInspectionDetailPhoto(inspectionDetailId: number): Observable<any> {
  const options = {
    params: new HttpParams()
    .set('inspectionDetailId', inspectionDetailId.toString())
  };
  return this._http.get(this.DELETE_TEMP_INSPECTION_DETAIL_PHOTO, options).pipe(catchError(this.handleError));
}

public updateInspectionDetailsTemperature(inspectionDetailId: number,tempearture:number,InspectionId:number): Observable<Tuple> {
  const options = {
    params: new HttpParams()
    .set('inspectionDetailId', inspectionDetailId.toString()).set('tempearture', tempearture.toString()).set('InspectionId', InspectionId.toString())
  };
  return this._http.get<Tuple>(this.UPDATE_TEMP_INSPECTION_DETAIL_TEMPERATURE, options).pipe(catchError(this.handleError));
}

public UpdateInspectionDateTemperature(model: UpdateTemperatureDateAmbient): Observable<Tuple> {
 
  return this._http.post<Tuple>(this.UPDATE_TEMP_INSPECTION_AMBIENT_TEMPERATURE_DATE, model).pipe(catchError(this.handleError));
}

public LoadTemperatureInspectionALLInspectionList(model: LoadInspectionListVM): Observable<TemperatureInspectionListVM[]> {
  return this._http.post<TemperatureInspectionListVM[]>('api/TemperatureInspection/LoadAllInspections', model).pipe(catchError(this.handleError));
}


private handleError(error: Response) {
  console.error(error);
  return Observable.throw(error.json().error || 'Server error');
}

}
